module.exports = __webpack_public_path__ + "29d202fa56ff3ca632ea31c10ba57a3d.svg";